import axios from 'axios'
import qs from 'qs'
import router from './router/index.js'
// var token = 'O2_L8iLs66yDS7397KNC_QHli4BepBOi5y7mV8CNR3gNaeX9IcXoTkhAol9OReZqThdLDPi96rGRbGELRRA5SexIDSc68iKkbKv8gSVk0HfAf0ES-oZ9g_WVWjVEKq332PMDSw_u3MrcfFNHF9meCo4dQ7ZlGS26wJdM0Nl60JTsse0bSEyt7UP-jkRKSjysbuMuOWT0RIEizoiXXLqx0gO70TvKmPFYWvEaXcC0MRbzW8DKOizTEKGSmk0vnn78IP3phHOS_8yYQuXd-lnmbHJc0vIf7WXhrL2K-GJ8Dp96Song9NDg_o92qoB4WJ0HwGiMsQrJqxef4yVG-YRDZg'
// axios.defaults.headers.Authorization = token
axios.defaults.timeout = 600000 // 响应时间
// axios.defaults.baseURL = 'http://localhost:62838'
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  // 在发送请求之前做某件事
  // if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
  //   config.data = qs.stringify(config.data)
  // }
  return config
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  // 对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res)
  }
  console.log(res.data.code)
  return res
}, (error) => {
  if (error.response.status == '401') {
    // localStorage.removeItem('Authorization');
    // this.$router.push('/login');
    router.push({
      path: '/login'
    })
  }
  console.log('网络异常')

  return Promise.reject(error)
})

// 返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/// /返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: param })
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default {
  fetchPost,
  fetchGet
}
